import { Box, Typography, Alert, Card, Stack, Slider } from "@mui/material";

const WithdrawalSliderSection = ({
  label,
  fee,
  balance,
  earnings,
  minAmount,
  t,
  onChange,
  showSlider = false,
  showCard = false,
  currency = "USD",
  dataConstant = { TwoDigitConstValue: 2 },
}) => {
  const feeParsed = parseFloat(fee || 0);
  const earningsParsed = parseFloat(earnings ?? 0);
  const minParsed = parseFloat(minAmount || 0);

  const totalSum = earningsParsed + feeParsed;
  const insufficientFunds = feeParsed > balance;
  const isBelowMinimum = earningsParsed < minParsed;
  const isExceedingBalance = totalSum > balance;
  const isValidAmount =
    !insufficientFunds && !isBelowMinimum && !isExceedingBalance;
  const displayAmount = isValidAmount
    ? earningsParsed.toFixed(dataConstant.TwoDigitConstValue)
    : earningsParsed.toFixed(dataConstant.TwoDigitConstValue);

  const content = (
    <>
      {showSlider && (
        <Box textAlign="center">
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              borderRadius: "10px",
              px: 0.5,
              py: 0.5,
            }}
          >
            <Typography variant="body1" color="secondary.text">
              $0
            </Typography>
            <Slider
              min={0}
              max={Math.max(balance - feeParsed, 0)}
              value={earningsParsed}
              step={1}
              onChange={(e, newValue) => {
                onChange(newValue);
              }}
              sx={{ mx: 2 }}
              disabled={insufficientFunds}
            />
            <Typography variant="body1" color="secondary.text">
              ${displayAmount}
            </Typography>
          </Box>
        </Box>
      )}
    </>
  );

  return (
    <Box>
      {showCard ? (
        <Box textAlign="center" mt={"20px"}>
          <Box textAlign="center">
            <Typography variant="body2" color="secondary.text">
              {label} {t("IWallet.Fee")} ${feeParsed.toFixed(2)} {currency}
            </Typography>
          </Box>
          <Box textAlign="center">
            {insufficientFunds && (
              <Alert severity="error" sx={{ mt: "20px" }}>
                {t("IWallet.InsufficientFunds")}
              </Alert>
            )}
            {isBelowMinimum && (
              <Alert severity="error" sx={{ textAlign: "left" }}>
                {t("IWallet.Total Withdrawal amount")} ${minParsed} {currency}{" "}
                {t("IWallet.and less than or equal to")} $
                {balance.toFixed(dataConstant.TwoDigitConstValue)} {currency}
              </Alert>
            )}
            {isExceedingBalance && !insufficientFunds && !isBelowMinimum && (
              <Alert severity="error" sx={{ textAlign: "left" }}>
                {t("IWallet.Total Withdrawal amount")} ${minParsed} {currency}{" "}
                {t("IWallet.and less than or equal to")} $
                {balance.toFixed(dataConstant.TwoDigitConstValue)} {currency}
              </Alert>
            )}
          </Box>
          <Card
            sx={(theme) => ({
              background: theme.palette.secondary.lightest,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "10px",
              width: "100%",
              mt: "20px",
            })}
          >
            <Stack sx={{ flexGrow: 1 }}>{content}</Stack>
          </Card>
        </Box>
      ) : (
        content
      )}
    </Box>
  );
};

export default WithdrawalSliderSection;
